var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateRepairProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 8.00033C8.99967 10.1203 7.28634 11.8337 5.16634 11.8337C3.04634 11.8337 1.33301 10.1203 1.33301 8.00033C1.33301 5.88033 3.04634 4.16699 5.16634 4.16699",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 8C6.66699 5.79333 8.46033 4 10.667 4C12.8737 4 14.667 5.79333 14.667 8C14.667 10.2067 12.8737 12 10.667 12",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRepairProject);
export default __webpack_public_path__ + "static/media/create-repair-project.40d57eec2912ed88dcb78f9b1739353d.svg";
export { ForwardRef as ReactComponent };